/* The Canadian Soul — small UI enhancements for Dawn (custom sort dropdown). */
(function () {
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CARET = '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function enhance(select) {
    if (select.dataset.csEnhanced) return;
    select.dataset.csEnhanced = '1';

    var wrap = document.createElement('div');
    wrap.className = 'cs-select';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cs-select__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var label = document.createElement('span');
    btn.appendChild(label);
    btn.insertAdjacentHTML('beforeend', CARET);

    var list = document.createElement('ul');
    list.className = 'cs-select__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    function sync() {
      var opt = select.options[select.selectedIndex];
      label.textContent = opt ? opt.text : '';
      Array.prototype.forEach.call(list.children, function (li, i) {
        li.setAttribute('aria-selected', i === select.selectedIndex ? 'true' : 'false');
      });
    }
    function open() {
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var cur = list.children[select.selectedIndex] || list.firstElementChild;
      if (cur) cur.focus();
    }
    function close() {
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function choose(i) {
      if (select.selectedIndex !== i) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('input', { bubbles: true }));
      }
      sync();
      close();
      btn.focus();
    }

    Array.prototype.forEach.call(select.options, function (o, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.innerHTML = '<span></span>' + CHECK;
      li.firstChild.textContent = o.text;
      li.addEventListener('click', function () { choose(i); });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(i); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); (li.nextElementSibling || li).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (li.previousElementSibling || li).focus(); }
        else if (e.key === 'Escape' || e.key === 'Tab') { close(); btn.focus(); }
      });
      list.appendChild(li);
    });

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (list.hidden) open(); else close();
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); open(); }
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });

    wrap.appendChild(btn);
    wrap.appendChild(list);
    select.classList.add('cs-select__native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    select.parentElement.insertBefore(wrap, select);
    if (select.parentElement.classList.contains('select')) select.parentElement.classList.add('select--cs');
    sync();
  }

  function run() {
    document.querySelectorAll('select[name="sort_by"]:not([data-cs-enhanced])').forEach(enhance);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
